import { createContext, useContext, useState, useCallback } from "react";

const NavCountsContext = createContext(null);

export function NavCountsProvider({ children }) {
    const [refetchKey, setRefetchKey] = useState(0);

    const triggerNavRefetch = useCallback(() => {
        setRefetchKey((k) => k + 1);
    }, []);

    return (
        <NavCountsContext.Provider value={{ refetchKey, triggerNavRefetch }}>
            {children}
        </NavCountsContext.Provider>
    );
}

export function useNavCountsContext() {
    const ctx = useContext(NavCountsContext);
    if (!ctx) throw new Error("useNavCountsContext must be used inside NavCountsProvider");
    return ctx;
}
